import React from 'react';

interface CodeToggleHandleProps {
  isOpen: boolean;
  onClick: () => void;
}

const CodeToggleHandle: React.FC<CodeToggleHandleProps> = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        fixed left-0 top-1/2 -translate-y-1/2 z-50
        px-1.5 py-3 rounded-r-md
        font-sans font-medium text-xs normal-case
        transition-all duration-300 ease-in-out
        flex items-center gap-1.5
        bg-transparent
        border-r border-t border-b
        ${isOpen
          ? 'border-blue-400/60 text-blue-400 hover:bg-blue-500/10'
          : 'border-gray-400/40 text-gray-500 dark:text-gray-400 hover:border-gray-500/60 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-500/5'
        }
      `}
      title={isOpen ? 'Close code editor (Esc)' : 'Open code editor'}
      style={{
        writingMode: 'vertical-rl',
        textOrientation: 'mixed'
      }}
    >
      {/* Icon rotated for vertical orientation */}
      <svg
        className="w-3 h-3"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        style={{ transform: 'rotate(-90deg)' }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
        />
      </svg>

      <span className="tracking-wide">CODE</span>

      {/* Arrow indicator */}
      <span className="text-[10px]">
        {isOpen ? '◀' : '▶'}
      </span>
    </button>
  );
};

export default CodeToggleHandle;
